Array.prototype.uniqualizeArrayElements = function () {
  let map = new Map()
  const uniqueInvitees = []

  this.forEach(person => map.set(person.id, person))
  map.forEach(invitee => uniqueInvitees.push(invitee))

  return uniqueInvitees
}
